import { Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import * as S from './PageNotFound.styled';
import { ContextValues } from 'App/session/Session.types';

export const PageNotFound = ({ initialPage }: { initialPage: ContextValues['initialPage'] }) => {
  return (
    <S.Container>
      <Typography fontWeight={600} fontSize={64}>
        404
      </Typography>
      <Stack alignItems='start' gap={1}>
        <Typography fontSize={16} padding='6px 8px'>
          Sorry, we could find that page
        </Typography>
        <Link to={initialPage} style={{ textDecoration: 'none' }}>
          <Button sx={{ textTransform: 'none', fontSize: 16 }}>Go back to the main page</Button>
        </Link>
      </Stack>
    </S.Container>
  );
};
